import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

export const departmentDetailService = {
  getDepartmentDetail: async (departmentId) => {
    try {
      const response = await axiosInstance.get(API.department.getById(departmentId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getJobTitles: async (departmentId) => {
    try {
      const response = await axiosInstance.get(API.jobTitle.getList(departmentId));
      return response.data;
    } catch (err) {
      throw err;
    }
  },

    getCareerPaths: async (departmentId) => {
    try {
      const response = await axiosInstance.get(API.careerPaths.getListByLookup(departmentId));
      return response.data;
    } catch (err) {
      throw err;
    }
  },

  getJobTitle: async (jobTitleId) => {
    try {
      const response = await axiosInstance.get(API.jobTitle.getById(jobTitleId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createJobTitle: async (payload) => {
    try {
      const response = await axiosInstance.post(API.jobTitle.create, payload);
      return response.data;
    } catch (error) {
      console.error("Error in creating Job Title", error);
      throw error;
    }
  },

  updateJobTitle: async (payload) => {
    try {
      const response = await axiosInstance.put(API.jobTitle.update, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getDepartmentList: async () => {
    try {
      const response = await axiosInstance.get(API.department.getListByLookup);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getEmployess: async (departmentId) => {
    try {
      const response = await axiosInstance.get(API.employee.getAll(departmentId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
